<template>
  <div style="height: 100%">
    <div v-if="columnSettingsKey || $slots.toolbar" class="table-toolbar">
      <span class="table-toolbar-left">
        <slot name="toolbar"></slot>
      </span>
      <span v-if="columnSettingsKey" class="table-toolbar-right">
        <a-icon
          type="setting"
          class="table-column-settings-icon"
          @click="openColumnSettings"
        />
      </span>
    </div>
    <a-table :ellipsis="true" :loading="loading" :columns="displayColumns" :customRender="customRender"
      :data-source="tableData" bordered :rowKey="(record, index) => index" size="small" :customRow="onClickRow"
      :pagination="pagination" :rowClassName="rowClassName" :scroll="{ x: 1200, y: 600 }">
      <!-- 首列序号 -->
      <template slot="index" slot-scope="scope, record">
        <template v-if="
          selectedRows && selectedRows[0] && record.orderId == selectedRows[0].orderId
        ">
          <a-radio :checked="true"></a-radio>
        </template>
        <template v-else>
          {{ scope }}
        </template>
      </template>
      <template slot="orderStatus" slot-scope="scope">
        {{ $t(orderStatusMap[scope.code]) }}
      </template>

      <template slot="estimatedWeight" slot-scope="scope">
        <span v-if="scope"> {{ filterToTwo(scope) }} {{ $t("ton") }}</span>
      </template>

      <template slot="isDeclaration" slot-scope="scope">
        <span v-if="scope !== null">{{ scope == true ? $t("yes") : $t("no") }}</span>
      </template>

      <template slot="containerWeighingDesc" slot-scope="scope">
        <span>{{ scope == null ? $t("notWeigh") : scope }}</span>
      </template>

      <template slot="trackStatus" slot-scope="scope, record">
        <span v-if="record.trackStatus">
          {{ $t(taskStatusMap[record.trackStatus.code]) }}</span>
      </template>

      <template slot="boundType" slot-scope="scope">
        {{ $t(boundTypeMap[scope.code]) }}
      </template>
      <template slot="receivableBoundType" slot-scope="scope">
        {{ scope.msg }}
      </template>
      <template slot="locationType" slot-scope="scope">
        {{ scope.value }}
      </template>
      <template slot="locationContactName" slot-scope="scope, record">
        <span v-if="record.locationContactName">
          <span v-for="(item, index) in record.locationContactName.split(',')" :key="index">{{ item }} <br />
          </span>
        </span>
      </template>
      <template slot="locationContactPhone" slot-scope="scope, record">
        <span v-if="record.locationContactPhone">
          <span v-for="(item, index) in record.locationContactPhone.split(',')" :key="index">{{ item }} <br />
          </span>
        </span>
      </template>

      <template slot="factoryContactName" slot-scope="scope, record">
        <span v-if="record.factoryContactName">
          <span v-for="(item, index) in record.factoryContactName.split(',')" :key="index">{{ item }} <br />
          </span>
        </span>
      </template>

      <template slot="factoryContactPhone" slot-scope="scope, record">
        <span v-if="record.factoryContactPhone">
          <span v-for="(item, index) in record.factoryContactPhone.split(',')" :key="index">{{ item }} <br />
          </span>
        </span>
      </template>

      <template slot="seeAttachement" slot-scope="scope, record">
        <slot name="option" v-bind:attach="record"></slot>
      </template>

      <!-- 做箱备注气泡 -->
      <template slot="remark" slot-scope="scope, record">
        <a-tooltip :title="record.remark" placement="left" :getPopupContainer="(triggerNode) => triggerNode.parentNode"
          arrow-point-at-center :overlayStyle="{ minWidth: '500px' }">
          <span class="popovername">{{ record ? record.remark : "" }}</span>
        </a-tooltip>
      </template>

      <!-- 重点订单要求气泡 -->
      <template slot="importantContainerReason" slot-scope="scope, record">
        <a-tooltip :title="record.importantContainerReason" placement="left" arrow-point-at-center>
          <span class="popovername">{{
            record ? record.importantContainerReason : ""
          }}</span>
        </a-tooltip>
      </template>

      <!-- 堆场气泡 -->
      <template slot="popover" slot-scope="scope, record">
        <a-tooltip :title="record.depot" placement="left" :getPopupContainer="(triggerNode) => triggerNode.parentNode"
          arrow-point-at-center>
          <span class="popovername">{{ record ? record.depot : "" }}</span>
        </a-tooltip>
      </template>

      <!-- 门点地址气泡 -->
      <template slot="factoryAddress" slot-scope="scope, record">
        <span v-if="record.factoryAddress" class="popovername">
          <a-tooltip :title="record.factoryAddress" placement="left"
            :getPopupContainer="(triggerNode) => triggerNode.parentNode" arrow-point-at-center>
            {{ record.factoryAddress }}
            <!-- <span
							v-for="(item, index) in record.factoryAddress.split(',')"
							:key="index"
							>{{ item }} <br />
						</span> -->
          </a-tooltip>
        </span>
      </template>
    </a-table>
    <a-modal
      :visible="columnSettingsVisible"
      :title="$t('columnSettings.title')"
      :width="480"
      :mask-closable="false"
      :body-style="{ maxHeight: '60vh', overflowY: 'auto', paddingRight: '16px' }"
      @cancel="closeColumnSettings"
    >
      <draggable
        :list="editingItems"
        :animation="150"
        item-key="key"
      >
        <div
          v-for="item in editingItems"
          :key="item.key"
          class="column-settings-row"
          :class="{ 'row-hidden': item.hidden }"
        >
          <a-checkbox
            :checked="!item.hidden"
            @change="(e) => onToggleColumn(item.key, e.target.checked)"
          >
            {{ item.title }}
          </a-checkbox>
        </div>
      </draggable>
      <template slot="footer">
        <a-button @click="closeColumnSettings">{{ $t('columnSettings.cancel') }}</a-button>
        <a-button type="primary" @click="saveColumnSettings">{{ $t('columnSettings.ok') }}</a-button>
      </template>
    </a-modal>
  </div>
</template>
<script>
import draggable from "vuedraggable";
import { filterToTwo } from "../../utils/filterToTwo";
import { orderStatusMap, boundTypeMap, taskStatusMap } from "../../constant/index";
import {
  getColumnSettings,
  setColumnSettings,
  mergeColumns,
} from "@/utils/column-settings";

export default {
  name: "table-fixed",
  components: { draggable },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    tableColumn: {
      type: Array,
      default() {
        return [];
      },
    },
    tableData: {
      type: Array,
      default() {
        return [];
      },
    },
    isSelect: {
      type: Boolean,
      default: false,
    },
    pagination: {
      type: Object,
      default() {
        return {};
      },
    },
    columnSettingsKey: {
      type: String,
      default: "",
    },
    lockedColumnKeys: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      selectedRowKeys: [],
      selectedRows: [],
      orderStatusMap,
      boundTypeMap,
      taskStatusMap,
      columnSettingsVisible: false,
      editingItems: [],
      settingsVersion: 0,
    };
  },
  computed: {
    displayColumns() {
      // eslint-disable-next-line no-unused-vars
      const _v = this.settingsVersion;
      const settings = getColumnSettings(this.columnSettingsKey);
      return mergeColumns(this.tableColumn, settings, this.lockedColumnKeys);
    },
  },
  watch: {
    tableData() {
      console.log(
        "this.tableData is changed === ",
        this.tableData,
        this.selectedRowKeys,
        this.selectedRows
      );
      this.selectedRowKeys = [];
      this.selectedRows = [];
      // 通知父单元情况选择数据
      this.selectChanged([]);
    },
  },
  created() { },
  methods: {
    filterToTwo,
    onSelectChange(selectedRowKeys, selectedRows) {
      console.log("selectedRowKeys changed: ", selectedRowKeys, selectedRows);
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
      this.selectChanged(selectedRows);
    },
    // 点击一行实现选中
    onClickRow(record, index) {
      const style = {};
      if (record.importantContainer && this.selectedRowKeys[0] !== index) {
        style.backgroundColor = "#f9f29e";
      }

      return {
        on: {
          click: () => {
            console.log("行事件", record, index);
            this.selectedRowKeys = [index];
            this.selectedRows = [record];
            this.selectChanged(this.selectedRows);
          },
          dblclick: () => {
            console.log("双击此行", record, index);
            this.selectedRowKeys = [index];
            this.selectedRows = [record];
            this.$emit("dbclickRow", this.selectedRows);
          },
          mouseenter: () => {
            this.rowClassName;
          }, // 鼠标移入行
        },
        style,
      };
    },
    rowClassName(record) {
      if (
        this.selectedRows &&
        this.selectedRows[0] &&
        record.orderId == this.selectedRows[0].orderId
      ) {
        return "ant-select-row";
      }
      return "";
    },
    // 通知父单元选择项发生变化
    selectChanged(selectedRows) {
      this.$emit("onSelectChange", selectedRows);
    },
    customRender(text, record, index) {
      console.log(text, record, index);
    },
    columnKeyOf(c) {
      if (c && typeof c.dataIndex === "string" && c.dataIndex !== "") return c.dataIndex;
      if (c && typeof c.title === "string" && c.title !== "") return c.title;
      return null;
    },
    columnTitleOf(c) {
      if (!c) return "";
      if (typeof c.title === "string") return c.title;
      return c.dataIndex || "";
    },
    buildEditingItems() {
      const settings = getColumnSettings(this.columnSettingsKey);
      const hiddenSet = new Set(settings.hidden);
      const lockedSet = new Set(this.lockedColumnKeys);
      const configurableCols = this.tableColumn.filter((c) => {
        const k = this.columnKeyOf(c);
        return k !== null && !lockedSet.has(k);
      });
      const order = settings.order && settings.order.length > 0
        ? settings.order
        : configurableCols.map((c) => this.columnKeyOf(c));
      const keyToCol = new Map();
      configurableCols.forEach((c) => {
        const k = this.columnKeyOf(c);
        if (k !== null) keyToCol.set(k, c);
      });
      const seen = new Set();
      const items = [];
      order.forEach((k) => {
        if (keyToCol.has(k) && !seen.has(k)) {
          seen.add(k);
          items.push({
            key: k,
            title: this.columnTitleOf(keyToCol.get(k)),
            hidden: hiddenSet.has(k),
          });
        }
      });
      configurableCols.forEach((c) => {
        const k = this.columnKeyOf(c);
        if (k !== null && !seen.has(k)) {
          seen.add(k);
          items.push({
            key: k,
            title: this.columnTitleOf(c),
            hidden: hiddenSet.has(k),
          });
        }
      });
      return items;
    },
    openColumnSettings() {
      this.editingItems = this.buildEditingItems();
      this.columnSettingsVisible = true;
    },
    closeColumnSettings() {
      this.columnSettingsVisible = false;
      this.editingItems = [];
    },
    onToggleColumn(key, checked) {
      const item = this.editingItems.find((i) => i.key === key);
      if (item) this.$set(item, "hidden", !checked);
    },
    saveColumnSettings() {
      setColumnSettings(this.columnSettingsKey, {
        order: this.editingItems.map((i) => i.key),
        hidden: this.editingItems.filter((i) => i.hidden).map((i) => i.key),
      });
      this.settingsVersion++;
      this.columnSettingsVisible = false;
      this.editingItems = [];
    },
  },
};
</script>
<style lang="less">
// .ant-tooltip-inner {
// 	min-width: 100px;
// 	white-space: break-spaces;
// }
// .popovername {
// 	display: -webkit-box;
// 	text-overflow: ellipsis;
// 	overflow: hidden;
// 	-webkit-line-clamp: 2;
// 	white-space: break-spaces;
// 	// width: 200px;
// 	-webkit-box-orient: vertical;
// }
// .ant-select-row {
// 	background-color: #cbf2ff;
// }
//</style>
<style scoped lang="less">
.ant-radio-wrapper {
  margin: 0;
}
.table-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  margin-bottom: 8px;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
}
.table-toolbar-left {
  display: flex;
  align-items: center;
  gap: 8px;
}
.table-toolbar-right {
  display: flex;
  align-items: center;
}
.table-column-settings-icon {
  font-size: 16px;
  cursor: pointer;
  color: #888;
}
.table-column-settings-icon:hover {
  color: #1890ff;
}
.column-settings-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 8px;
  border: 1px solid #e8e8e8;
  margin-bottom: 4px;
  background: #fff;
  cursor: grab;
  user-select: none;
}
.column-settings-row:hover {
  border-color: #1890ff;
}
.column-settings-row:active {
  cursor: grabbing;
}
.column-settings-row.row-hidden {
  opacity: 0.5;
  background: #fafafa;
}
</style>
